import { Grid, Typography } from '@material-ui/core';
import React, { FC } from 'react';

import { Caret } from 'src/Icons';
import { Action } from 'src/StatusLabel';
import { StatusLabelClassNames } from 'src/types';

export interface StatusLabelMenuActionsProps {
  actions: Action[];
  handleClose: () => void;
}

export const StatusLabelMenuActions: FC<StatusLabelMenuActionsProps> = ({ actions, handleClose }) => {
  const handleClick = (callback: () => void) => (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    handleClose();
    callback();
  };
  return (
    <>
      {actions.map(action => (
        <Grid
          key={action.label}
          className={StatusLabelClassNames.MENU_ACTIONS}
          component="li"
          onClick={handleClick(action.onClick)}
        >
          <Typography component="p" noWrap variant="overline">
            {action.label}
          </Typography>
          <Caret className={StatusLabelClassNames.ACTION_ICON} />
        </Grid>
      ))}
    </>
  );
};
